module.exports = __webpack_public_path__ + "img/section3.d2c9ce7d.png";